// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__zLZfy","content":"styles_content__1Fevu","selectAll":"styles_selectAll__1itEP"};